import type { PaletteColorOptions } from "@mui/material";

declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    xxl: true;
  }

  interface CustomPalette {
    cyan: PaletteColorOptions;
    green: PaletteColorOptions;
    yellow: PaletteColorOptions;
    orange: PaletteColorOptions;
    magenta: PaletteColorOptions;
    purple: PaletteColorOptions;
    dark: PaletteColorOptions;
  }

  interface Palette extends CustomPalette {}

  interface PaletteOptions extends CustomPalette {}
}

export const CovestroColors = {
  cyan: {
    light: "#4DBCEC",
    main: "#009FE4",
    dark: "#007FB6",
    contrastText: "#FFFFFF",
  },
  green: {
    light: "#4CCFA4",
    main: "#00BB7E",
    dark: "#008258",
    contrastText: "#FFFFFF",
  },
  yellow: {
    light: "#fff34c",
    main: "#FFEE00",
    dark: "#b2a600",
    contrastText: "#262626",
  },
  orange: {
    light: "#ffa57a",
    main: "#FF7F41",
    dark: "#b2582d",
    contrastText: "#FFFFFF",
  },
  magenta: {
    light: "#ed4ca4",
    main: "#E6007E",
    dark: "#a10058",
    contrastText: "#FFFFFF",
  },
  purple: {
    light: "#a488d7",
    main: "#7D55C7",
    dark: "#573b8b",
    contrastText: "#FFFFFF",
  },
  dark: {
    light: "#999999",
    main: "#262626",
    dark: "#000000",
    contrastText: "#FFFFFF",
  },
};

export const CovestroFontColor = "#1A1A1A";
export const CovestroBackgroundColor = "#F2F2F2";
